var agent = {
    text1:"AGENT REGISTRATION",
    badge: "Agent registration",
    intro:
      "To register as an agent, first find your agency and select it. If it is not yet in the system, you can create it here and continue with your registration right away.",
    step1: "Find your agency by name or create a new one if needed.",
    step2: "Confirm the details of the selected agency.",
    step3: "Complete your personal information to activate your access.",
    alternateFlowPrefix: "If the one registering is the agency and not an agent, use the",
    alternateFlowSuffix: "Now.",
    searchHelper:
      "Search for the agent's agency and select it. If it does not exist yet, you can create it here to continue with this registration.",
    searchButtonText: "Register agency",
    searchButtonTitle: "Register agency",
    search: {
      label: "Step 1. Find your agency",
      placeholder: "Type the agency name...",
      helperText:
        "Search for the agent's agency and select it. If it does not exist yet, you can create it here to continue with this registration.",
      buttonText: "Register agency",
      buttonTitle: "Register agency",
      clearSearchAria: "Clear search",
      panelHeader: "Search results",
      loading: "Searching agencies...",
      selectBadge: "Select",
      addressLabel: "Address:",
      phoneLabel: "Phone:",
      emptyTitle: "We could not find agencies",
      emptyTextPrefix: "There are no matches for",
      emptyTextSuffix: 'You can register a new agency.',
      emptyActionButtonText: "Register new agency",
      emptyStateText: "Type to start searching."
    },
    selectedAgency: {
      emptyTitle: "You have not selected an agency yet",
      emptyText:
        "Once you choose one, you will see its details here before continuing with the agent registration.",
      titlePrefix: "Selected agency:",
      clearButton: "Clear",
      addressLabel: "Address:",
      phoneLabel: "Phone:",
      unavailable: "Not available",
      noName: "No name"
    },
    form: {
      waitingAgencyMessage:
        "Step 2. Select or create an agency to enable the registration form.",
      title: "Step 2. Complete your details",
      subtitle:
        "Enter the agent information to complete the registration and activate access.",
      success: "Registration submitted successfully.",
      requiredFieldsError: "Please complete all fields.",
      passwordMismatchError: "Passwords do not match.",
      termsError: "You must accept the terms and conditions.",
      policiesError: "You must accept the Privacy Notice and Cookie Policy.",
      submitError: "An error occurred while submitting the form.",
      fullNameLabel: "Full name",
      fullNamePlaceholder: "Enter your full name",
      emailLabel: "Email address",
      emailPlaceholder: "example@email.com",
      phoneLabel: "Phone",
      phonePlaceholder: "Your phone number",
      cityLabel: "City",
      cityPlaceholder: "Your city",
      agencyLabel: "Agency / Company",
      agencyPlaceholder: "Selected agency",
      passwordLabel: "Password",
      passwordPlaceholder: "********",
      confirmPasswordLabel: "Confirm password",
      confirmPasswordPlaceholder: "********",
      termsTextBefore: "I have read and accept the terms and conditions for the use of ",
      termsLinkText: "Marival Resorts’ multimedia materials",
      termsTextAfter: ".",
      policiesTextBefore: "I have read and accept the terms of the ",
      policiesPrivacyLink: "Privacy Notice",
      policiesTextMiddle: " and ",
      policiesCookieLink: "Cookie Policy",
      policiesTextAfter: ".",
      submitting: "Submitting...",
      submitButton: "Create account"
    }
}
module.exports = agent
